import React from 'react';
import { filterType } from '../../../../../../../types';
import Toggle, { TogglePropTypes } from '../toggle';

const SellerOnlineToggle = ({ filter, ...rest }) => {
    if (!filter){ return null;}

    return (
        <Toggle className="local-filter"
            selectedValue={true}
            title="search_perseus.filters.global.is_seller_online.title"
            text="search_perseus.filters.global.is_seller_online.text"
            {...filter}
            {...rest}/>
    );};

SellerOnlineToggle.propTypes = {
    filter: filterType,
    ...TogglePropTypes
};

export default SellerOnlineToggle;
